import * as o from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/BookOpenText.es.js";
const e = o.forwardRef((t, r) => /* @__PURE__ */ o.createElement(n, { ref: r, ...t, weights: a }));
e.displayName = "BookOpenTextIcon";
const c = e;
export {
  c as BookOpenText,
  e as BookOpenTextIcon
};
